'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$60() {
  this.bF1 = null;
  this.bF2 = false;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$60 as $c_Lpresto_TwoFactorAuthView$$anon$60 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$60.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$60;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$60() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$60 as $h_Lpresto_TwoFactorAuthView$$anon$60 };
$h_Lpresto_TwoFactorAuthView$$anon$60.prototype = $p;
$p.P = (function() {
  if ((!this.bF2)) {
    this.bF1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T6($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$());
    this.bF2 = true;
  }
  return this.bF1;
});
var $d_Lpresto_TwoFactorAuthView$$anon$60 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$60, "presto.TwoFactorAuthView$$anon$60", ({
  Tl: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$60 as $d_Lpresto_TwoFactorAuthView$$anon$60 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$60.js.map
